import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const Loader = ({ label = "Loading" }) => (
  <div data-testid="page-loader" className="flex min-h-[40vh] items-center justify-center">
    <div className="flex items-center gap-3 text-sm text-muted-foreground">
      <span className="h-2 w-2 animate-pulse rounded-full bg-brand-primary" />
      {label}…
    </div>
  </div>
);

export const ProtectedRoute = ({ children, admin = false }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (user.must_change_password && location.pathname !== "/change-password") return <Navigate to="/change-password" replace />;
  if (!user.must_change_password && !user.track && location.pathname !== "/choose-track") return <Navigate to="/choose-track" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};
